import CustomAd from 'components/advertisments/CustomAd'

import styles from './inhouseFixedAd.module.scss'

const InhouseFixedAd = () => {
  return (
    <>
      <div className={styles.desktopAdheasion} id="demo-fixed-ad">
        Demo fixed ad
      </div>

      <CustomAd className={styles.mobileAdheasion} />
    </>
  )
}

export default InhouseFixedAd
